import Vue from 'vue'
import store from '../store'

export default [
  {
    path: '/laudos',
    name: 'laudos-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getPaginateLaudos')
      next()
    },
    meta: {
      title: 'Laudos técnicos',
      paginateMethod: 'getPaginateLaudos',
      paginateAttr: 'paginateLaudos',
      twoLines: true,
      subtitleAttr: item => Vue.options.filters.date(item['data_coleta']),
      titleAttr: item => item['nome_cliente'],
      routeToCreate: 'laudos-importar-index',
      routeToEdit: 'laudos-update',
      emptyList: 'Nenhum laudo foi importado.',
      avatarIcon: 'ballot',
      pageAttr: 'laudoPage',
      pageCommit: 'setLaudoPage',
      filterAttr: 'laudoFilter',
      filterCommit: 'setLaudoFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/laudos/importar',
    name: 'laudos-importar-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getIndustrias')
      next()
    },
    meta: {
      title: 'Importar laudos técnicos',
      manual: true,
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/laudo/upload')
    }
  },
  {
    path: '/laudos/novo',
    name: 'laudos-create',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getContratos')
      await store.commit('setLaudo', {})
      next()
    },
    meta: {
      title: 'Novo laudo técnico',
      manual: false,
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/laudo/id')
    }
  },
  {
    path: '/laudos/:id',
    name: 'laudos-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getContratos')
      await store.dispatch('getLaudo', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar laudo',
      manual: false,
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/laudo/id')
    }
  }
]
